import { AttachmentsSection } from '@components'

import { useScrollToElement } from '@billy/design-system'
import { ReactElement, useRef } from 'react'

import { useSendAsEmailForm } from '../../../../../../contexts/sendAsEmailFormContext'

export const Attachments = (): ReactElement => {
  const { sendAsEmailForm } = useSendAsEmailForm()
  const attachmentsRef = useRef<HTMLDivElement>(null)

  const {
    FormItem,
    formState: { errors },
  } = sendAsEmailForm
  const attachmentsError = errors?.attachmentUuids?.message

  useScrollToElement(attachmentsRef, !!attachmentsError)

  return (
    <FormItem
      name="attachmentUuids"
      render={({ field: { onChange } }) => <AttachmentsSection onAttachmentsUpload={onChange} ref={attachmentsRef} />}
    />
  )
}
